<template>
    <div style="min-height: 400px;">
        <b-row>
            <b-col cols="auto" class="mr-auto">
            </b-col>
            <b-col cols="auto" class="">
                <b-form-group>
                    <b-button variant="github" class="mr-1 btn-brand" @click="openModal()"><i class="fa fa-plus"></i><span>Novo Arquivo</span></b-button>
                </b-form-group>
            </b-col>
        </b-row>
        
        <b-table :items="items" :fields="table.fields" :select-mode="table.selectMode" responsive="sm" primary-key="id" 
                :tbody-transition-props="table.transProps" sort-icon-left
                per-page="50" current-page="1" :busy="table.isBusy" hover striped style="min-height: 200px;">

            <template v-slot:cell(attachment)="data">
                <b-button size="sm" variant="primary" class="mr-1 btn-brand" @click="openDocumentModal(data.item)"><i class="fa fa-file-o"></i></b-button>
            </template>
            
            <template v-slot:cell(paymentDate)="data">
                {{ $utils.localDate(data.item.paymentDate) }}
            </template>


            <template v-slot:cell(totalValue)="data">
                R$ {{ $utils.numberFormat(data.item.totalValue) }}
            </template>

            <template v-slot:cell(action)="data">
                <b-button size="sm" variant="danger" @click="deleteItem(data.item)" class="mr-1 btn-brand"><i class="fa fa-times"></i></b-button>                  
            </template>

        </b-table>
  
        <b-modal v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Arquivo"
              size="md">

              <b-form enctype="multipart/form-data">

                <b-row>
                    <b-col md="12">
                        <b-form-group
                        description=""
                        label="Anexo"
                        label-for="attachment"
                        :label-cols="3"
                        :horizontal="false">
                            <file-drop-area-component v-model="fileToSend"></file-drop-area-component>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-group
                        description=""
                        label="Descrição"
                        label-for="description"
                        :label-cols="3"
                        :horizontal="false">
                            
                        <b-form-textarea
                                id="description"
                                v-model="fileDescription"
                                placeholder="Descrição do arquivo"
                                rows="3"
                        ></b-form-textarea>
                        
                        </b-form-group>          
                    </b-col>
                </b-row>


                <div slot="footer" class="text-right">
                    <b-button variant="github" class="mr-1 btn-brand" @click="addFile()"><i class="fa fa-check"></i><span>Adicionar Arquivo</span></b-button>
                </div>
                
              </b-form>
        </b-modal>


        <b-modal title="Arquivo" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedDocument">
          <div class="ratio ratio-16x9">        
              <iframe
              :src="this.selectedDocument.fullPath"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>

        
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";
import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'

export default {
    name: 'accountsFileGridComponent',
    props: {
        item: {},
        accountType: String,
        companyId: String
    },
    components: {
        FileDropAreaComponent
    },
    data: () => {
        return {
            selectedDocument: null,
            paymentValue: 0,
            fileToSend: null,
            fileDescription: '',
            editModal: false,
            items: [],
            table: {
                fields: [
                    //{key: 'show_details', label: "", thStyle: { width: "30px" } },
                    { key: 'filename', label: 'Arquivo', sortable: true },
                    { key: 'description', label: 'Descrição' },
                    //{ key: 'quantity', label: 'Quantidade', thStyle: { width: "120px" } },
                    //{ key: 'itemDiscount', label: 'Desconto', sortable: false, thStyle: { width: "120px" } },
                    //{ key: 'totalValue', label: 'Valor Total', thStyle: { width: "120px" }, tdClass: 'text-right' }
                    //{ key: 'description', label: 'Descrição', sortable: true},
                    //{ key: 'action2', label: '', sortable: false, thStyle: { width: "40px" } },                    
                    {key: 'attachment', label: "", thStyle: { width: "25px" } },
                    
                ],
                selectMode: 'single',
                isBusy: false,
                primaryKey: "id",
                transProps: {
                    name: 'flip-list'
                }

            },
            
        }
    },
    computed: {
        currentAccount() {
            return this.item
        },
        totalAccount() {
            var total = this.item.totalValue
            if(this.item.fees)
               total = total + this.item.fees
            if(this.item.discount)
               total = total = this.item.discount
            return total
        },
        totalToPay() {
            var total = this.totalAccount
            if(this.paymentValue)
               total = total - this.paymentValue
            return total

        },
        diffValue() {
          
          var diff = this.totalToPay
          if(this.paymentValue)
            diff = diff - this.paymentValue
            // (this.accountTotalValue ? this.accountTotalValue : 0) - (this.paymentValue ? this.paymentValue : 0)
          this.$emit("diff-changed", diff)

          return diff
       }
    },
    methods: {
        async addFile() {
            if(this.fileToSend) {
                var s = this;
                var currentUser = this.$store.state.currentUser;

                let formData = new FormData();

                formData.append('accountId', s.currentAccount.id)
                formData.append("description", s.fileDescription )
                formData.append('file', s.fileToSend);
                formData.append('uid', currentUser.id);
                formData.append('sid', currentUser.sid);
                
                var url = this.$store.state.ws_url + "/finance/ap/file"
                if(s.accountType == 'R')
                    url = this.$store.state.ws_url + "/finance/ar/file"

                console.log(url)

                await axios.post(
                    url,
                    formData
                ).then(function(resp) {
                    s.refreshData()
                    s.closeModal()

                }).catch(function(error) {
                    console.log(error)
                })
            }
        },
        async deleteItem(item) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            var url = this.$store.state.ws_url + "/finance/ap/file?accountId=" + s.currentAccount.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            if(s.accountType == 'R') {
                url = this.$store.state.ws_url + "/finance/ar/file?accountId=" + s.currentAccount.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            }
            await axios.delete(
                url
            ).then(function(resp) {
                s.refreshData()
            }).catch(function(error) {
                console.log(error)
            })

        },
        openDocumentModal(item) {
            this.selectedDocument = item;
            this.documentModal=true;
        },
        openModal() {
            this.fileToSend = null
            this.fileDescription = ''
            this.editModal = true
        },
        closeModal() {
            this.editModal = false
        },
        
        handleSelectedPayment(obj) {
            this.closeModal();
            this.refreshData();
        },
        
        async getFiles() {
            var s = this;
            if(s.currentAccount && s.currentAccount.id) {
                var currentUser = this.$store.state.currentUser;
                var url = this.$store.state.ws_url + "/finance/ap/file?accountId=" + s.currentAccount.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                if(s.accountType == 'R') {
                    url = this.$store.state.ws_url + "/finance/ar/file?accountId=" + s.currentAccount.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                }

                await axios.get(
                    url
                ).then(function(resp) {
                    s.items = resp.data.obj;

                }).catch(function (error) {
                    console.log(error);
                    s.items = []
                });
            }
            
        },

        refreshData() {
            this.getFiles()
        }
    },
    mounted: function() {
        this.refreshData()
    }

}

</script>